const invalidOptionsError = (line, match) => {
  const { options } = match.groups;
  return `the options you passed ${options} are syntactically invalid ${printFormattedError(line, options)}`;
};
const invalidTephraSyntax = line => {
  const msg = `the tephra include is invalid, make sure that you are using valid syntax`;
  return `${msg} ${printFormattedError(line, line.content)}`;
};

const invalidHex = (line, match) => {
  const { hexHash, hex } = match.groups;
  const mgs = `the tephra include has an invalid hex value "${hexHash}" hex can only be a string`;
  return `${mgs} ${printFormattedError(line, hex)}
    `;
};
export default {
  invalidOptionsError,
  invalidTephraSyntax,
  invalidHex
};

function printFormattedError(line, target) {
  line = { ...line };
  line.content = line.content.trim();
  line.prevLine = line.prevLine ? line.prevLine.trim() : "";
  const prevPos = lineNumber(line.position);
  const pos = lineNumber(line.position + 1, true);
  return `\n
    ${line.prevLine ? `${prevPos} ${line.prevLine}` : ""}

    ${pos} ${line.content}
      ${printErrorHighlight(line.content, target)}
  `;
}
function printErrorHighlight(line, target) {
  const targetIndex = line.indexOf(target);
  return (
    "     " +
    Array.from(line)
      .map((i, idx) => (idx >= targetIndex && idx < target.length - 1 + targetIndex ? "^" : " "))
      .join("")
  );
}

function lineNumber(pos, target = false) {
  const posStr = Array.from(String(pos));
  let finalStr = "";
  for (let idx = 1; idx < 5; idx++) {
    if (target && idx == 1) {
      finalStr += ">";
    } else if (posStr.length >= 5 - idx) {
      finalStr += posStr.shift();
    } else {
      finalStr += " ";
    }
  }
  return `${finalStr} |`;
}
